export const EstablishmentSetting = {
    HIDE_CALENDARS_PUBLIC_PAGE: 8,
    ACTIVATE_SEARCH_IN_ALL_SCHEDULES: 10,
    KPI_AVAILABILITY_DELAY: 15,
    ENABLE_OPEN_TO_PUBLIC: 16,
    ENABLE_FOOTER_INFO: 17,
    USE_CLIENT_LOGO: 20,
    CLIENT_LOGO: 21,
    PUBLISH_NEW_DAYS: 22,
    AMOUNT_SAVED_PUBLIC_APPOINTMENT: 23,
    USE_CUSTOM_TIMEZONE: 24,
    DEFAULT_TIMEZONE: 25,
    ENABLE_VIRTUAL_SERVICES: 26,
    ENABLE_REMINDER_REPORT: 27,
    ENABLE_RELAUNCH_REPORT: 28,
    ENABLE_ZIP_CODE_FILTER: 29,
    MODULES: 32,
    DISABLE_COMMUNICATIONS: 35,
    PRIVATE: 36,
    ALLOW_PREST_OVERRIDE: 37,
    ENABLE_ADMIN_SERVICES: 38,
    ENABLE_PRIVATE_ADMIN_SERVICES: 39,
    ENABLE_CUSTOM_TIMEZONE: 53,
    DISABLE_GOOGLE_ANALYTICS: 60,
    ENABLE_SMS: 78,
    THEMING_OVERRIDE: 153,
    CLIENT_LOGOMARK: 154,
    CO_ADMINISTRATION_FLU_COVID: 188,
    ESTABLISHMENT_TYPE: 193,
    SHOW_CONTACT_US_PUBLIC_PAGE: 201,
    ENABLE_DATA_COLLECTION_FORMS: 203,
};

export const ServiceTemplateEnum = {
    VACCINATION_GRIPPE: 195,
    VACCINATION_COVID_19: 204,
    PRISE_DE_SANG: 227,
    SHINGLES_VACCINE: 275,
};

export const ServiceSettings = {
    VACCINE_DELAY_MIN: 42,
    VACCINE_DELAY_MAX: 43,
    VACCINE_DELAY_MIN_MONTHS: 44,
    VACCINE_DELAY_MAX_MONTHS: 45,
    VACCINE_TOLERANCE_BEFORE: 46,
    VACCINE_TOLERANCE_AFTER: 47,
    IS_VIRTUAL_SERVICE: 48,
    VIRTUAL_SERVICE_APP: 49,
    ENABLE_FILTER_QUESTIONS: 50,
    FILTER_QUESTIONS: 51,
    FILTER_MESSAGES: 52,
    VIRTUAL_SERVICE_MESSAGE_DELAY: 52,
    IS_ADMIN_SERVICE: 54,
    IS_PRIVATE_ADMIN_SERVICE: 55,
    SUBMODULES: 56,
    ENABLE_NEXT_SERVICE_TO_BOOK_FOLLOW_UP: 58,
    NEXT_SERVICE_TO_BOOK: 59,
    PREGNANCY_DELAY_MIN: 62,
    PREGNANCY_DELAY_MAX: 63,
    PREGNANCY_DELAY_MIN_DAYS: 64,
    PREGNANCY_DELAY_MAX_DAYS: 65,
    PREGNANCY_TOLERANCE_BEFORE: 66,
    PREGNANCY_TOLERANCE_AFTER: 67,
    TRAVEL_MIN_TRAVELER_COUNT: 116,
    TRAVEL_MAX_TRAVELER_COUNT: 117,
    TRAVEL_COUNTRY_LIST: 118,
    TRAVEL_MAX_DAYS_AHEAD: 119,
    DRUG_INJECTION_LIST: 120,
    WORK_LOCATION_LIST: 123,
    EMPLOYER_NAME_LIST: 124,
    JOB_TITLE_LIST: 125,
    EMPLOYEE_ESTABLISHMENT_LIST: 128,
    EMPLOYEE_CATEGORY_LIST: 129,
    MIN_AGE_TO_BOOK_PATIENT: 132,
    MIN_AGE_TO_BOOK_ACCOMPANYING_PERSON: 133,
    MIN_AGE_TO_BOOK_HEALTH_WORKER: 137,
    MIN_AGE_TO_BOOK_ESSENTIAL_HEALTH_WORKER: 138,
    MIN_AGE_TO_BOOK_CHRONIC_DISEASE: 139,
    PRIORITY_GROUP_OPTIONS: 140,
    DISALLOW_PUBLIC_CANCELLATION: 141,
    MIN_AGE_TO_BOOK_HANDICAPPED: 142,
    MIN_AGE_TO_BOOK_HANDICAPPED_ACCOMPAGNATOR: 143,
    MIN_AGE_TO_BOOK_PREGNANT_WOMAN: 144,
    MIN_AGE_TO_BOOK_DAY_CAMP_WORKER: 145,
    MIN_AGE_TO_BOOK_REQUIRES_CONSENT: 146,
    COVID_2ND_DELAY_MIN_DAYS: 147,
    COVID_2ND_DELAY_MAX_DAYS: 148,
    FLU_TARIFICATION_MODE_VALUE: 158,
    SPECIFIC_SERVICE: 184,
    OTHER_SERVICE: 185,
    CIVIL_STATUS_LIST: 190,
    EMERGENCY_CONTACT_RELATIONSHIP: 191,
    MAX_AGE_TO_BOOK_PATIENT: 192,
    MIN_AGE_TO_BOOK_IMMUNOCOMPROMISED: 179,
    METADATA_DISPLAY_ORDER: 200,
    ENABLE_ESTABLISHMENT_SERVICE_TEMPLATES_FORMS: 204,
};

export const ConfigurationMessageEnum = {
    ABSENT_CLIENT_REMINDER: 1,
    APPOINTMENT_CONFIRMATION_REQUEST: 2,
    APPOINTMENT_CONFIRMATION_REQUEST_LAST_MINUTE: 3,
    CANCELLED_APPOINTMENT: 4,
    CANCELLED_APPOINTMENT_REMINDER: 5,
    FUTURE_APPOINTMENTS: 6,
    LAST_MINUTE_CANCELLATION_APPOINTMENT: 7,
    LAST_MINUTE_NEW_APPOINTMENT: 8,
    NEW_APPOINTMENT: 9,
    SCHEDULED_APPOINTMENT_BOOK_REMINDER: 10,
    SCHEDULED_APPOINTMENT_CONFIRMATION_REQUEST: 11,
    VIRTUAL_APPOINTMENT_REMINDER: 12,
    NEW_MULTIPLE_APPOINTMENT: 13,
    NEXT_SERVICE_TO_BOOK_FOLLOW_UP: 14,
};

export const MessageTypeEnum = {
    MAIL: 1,
    SMS: 2,
};

export const GlobalSettings = {
    METADATA_DISPLAY_ORDER_FEATURE_FLAG: 199,
};

export const MetadataEnumCovidScreening = {
    COVID_SCREENING_HEALTHCARE_WORKER: 106,
    COVID_SCREENING_HEALTHCARE_WORKER_TYPE: 107,
    COVID_SCREENING_HEALTHCARE_INSTITUTION: 108,
    COVID_SCREENING_HEALTHCARE_INSTITUTION_TYPE: 109,
    COVID_SCREENING_HEALTHCARE_SHARING_RESULT: 110,
    COVID_SCREENING_CONSENT_SHARING_INFORMATIONS: 112,
    COVID_SCREENING_CONSENT_RECEIVE_RESULT_BY_EMAIL_SMS: 113,
    COVID_SCREENING_PREFERRED_COMMUNICATION: 114,
    COVID_SCREENING_TRAVELLED_OUTSIDE_QUEBEC: 115,
    COVID_SCREENING_COUNTRY: 116,
    COVID_SCREENING_CATEGORY: 117,
    COVID_SCREENING_STUDENT_SCHOOL_REGION: 118,
    COVID_SCREENING_STUDENT_LEVEL: 119,
    COVID_SCREENING_STUDENT_INSTITUTION: 120,
    COVID_SCREENING_WORKING_QUEBEC: 121,
    COVID_SCREENING_EMPLOYER_NAME: 122,
    COVID_SCREENING_CHILD_NAME_OF_NURSERY: 123,
    COVID_SCREENING_OUTBREAK_NUMBER: 124,
};

export const MetadataEnumSampling = {
    HAVE_YOU_BEEN_TO_HOSPITAL_IN_THE_LAST_THREE_MONTHS: 126,
    CIVIL_STATUS: 127,
    SPOUSE_FIRST_NAME: 128,
    SPOUSE_LAST_NAME: 129,
    EMERGENCY_CONTACT_FIRST_NAME: 130,
    EMERGENCY_CONTACT_LAST_NAME: 131,
    EMERGENCY_CONTACT_RELATIONSHIP: 132,
    EMERGENCY_CONTACT_PHONE_NUMBER: 133,
};

export const MetadataEnumAs624 = {
    AS624_HEALTH_PROBLEMS_QUESTION: 136,
    AS624_IMMUNOSUPPRESSION_QUESTION: 137,
    AS624_ALLERGIC_REACTIONS_QUESTION: 138,
    AS624_BLEEDING_DISORDER_QUESTION: 139,
    AS624_HAS_BLOOD_TRANSFUSION_QUESTION: 140,
    AS624_PREGNANCY_QUESTION: 141,
    AS624_LESS_THAN_SIX_MONTHS_MOTHER_TREATMENT_QUESTION: 142,
};

export const EstablishmentTypeEnum =
{
    PHARMACY: 'pharmacie',
    PRIVATE_CLINIC: 'clinique_privee',
    HEALTH_ESTABLISHMENT: 'etablissement_de_sante',
    DEMO: 'demo',
};

export const MetadataEnum = {
    FIRST_NAME: 1,
    LAST_NAME: 2,
    EMAIL: 3,
    BIRTHDAY: 4,
    PHONE: 5,
    CELLPHONE: 6,
    COMMENTS: 7,
    CONFIRMATION_URL: 8,
    CANCELLATION_URL: 9,
    VIRTUAL_ACCOUNT: 10,
    REACTS_EVENT_URL: 11,
    REACTS_EVENT_ID: 12,
    PREGNANCY_DPA: 16,
    RESIDENT_FIRST_NAME_INITIAL: 17,
    RESIDENT_LAST_NAME: 18,
    RESIDENT_ROOM_NUMBER: 19,
    RESIDENT_BIRTHDAY_MONTH: 20,
    RESIDENT_CONTACT_ALLOW_ZOOM: 21,
    RESIDENT_CONTACT_ALTERNATIVE: 22,
    RESIDENT_MULTIPLE_USERS: 23,
    NAM: 24,
    SCANNED_REQUEST: 25,
    DOCTOR_NAME: 26,
    DRUG_NAME: 27,
    TRAVEL_TRAVELER_COUNT: 28,
    TRAVEL_TRAVELERS_INFO: 29,
    TRAVEL_DESTINATION_COUNTRY: 30,
    TRAVEL_DEPARTURE_DATE: 31,
    ADDRESS: 32,
    OCCUPATION: 33,
    BIRTH_PREMATURE: 34,
    BIRTH_PREMATURE_WEEK_COUNT: 35,
    TUTOR_FIRST_NAME: 36,
    TUTOR_LAST_NAME: 37,
    TUTOR_OCCUPATION: 38,
    UNKNOWN_MOTHER: 39,
    MOTHER_FIRST_NAME: 40,
    MOTHER_LAST_NAME: 41,
    UNKNOWN_FATHER: 42,
    FATHER_FIRST_NAME: 43,
    FATHER_LAST_NAME: 44,
    GENDER: 45,
    PROFILE_NUMBER: 46,
    SCHOOL_NAME: 47,
    VACCINE_TARGET: 48,
    REQUESTER_LINK: 49,
    REQUESTER_NAME: 50,
    GEOLOC_SHORT_POSTCODE: 51,
    COMM_PHONE_ONLY: 52,
    CONSENT_FORM_CONFIRMATION_CODE: 53,
    VACCINE_SECURITY_ACCEPTANCE: 54,
    EMPLOYEE_NUMBER: 55,
    EMPLOYER_NAME: 56,
    WORK_LOCATION: 57,
    JOB_TITLE: 58,
    EMPLOYEE_ESTABLISHMENT: 60,
    EMPLOYEE_CATEGORY: 61,
    AH635_HEALTH_PROBLEMS_QUESTION: 62,
    AH635_IMMUNOSUPPRESSION_QUESTION: 63,
    AH635_ALLERGIC_REACTIONS_QUESTION: 64,
    AH635_PREGNANCY_QUESTION: 65,
    AH635_BLEEDING_DISORDER_QUESTION: 66,
    AH635_IMMUNIZATION_QUESTION: 67,
    ACCOMPANYING_PERSON: 68,
    PRIORITY_GROUP: 69,
    P_CODE: 70,
    INFLUENZA_HEALTH_STATUS: 71,
    INFLUENZA_IS_IMMUNOSUPPRESSIVE: 72,
    INFLUENZA_HAS_SEVERE_REACTION: 73,
    INFLUENZA_IS_PREGNANT: 74,
    INFLUENZA_RECEIVED_VACCINE_LAST_MONTH: 75,
    INFLUENZA_HAS_IMMUNOCOMPROMISED_CONTACT: 76,
    INFLUENZA_PEOPLE_WHO_LIVE_WITH_ME: 77,
    INFLUENZA_HAS_BLOOD_TRANSFUSION: 78,
    INFLUENZA_RECEIVED_PNEUMOCOCCAL_VACCINE: 79,
    INFLUENZA_IS_HEALTH_CARE_WORKER: 80,
    INFLUENZA_RECEIVED_SHINGLES_VACCINE: 81,
    COVERED_RAMQ: 82,
    VACCINE_APPREHENSION: 83,
    SCHOOL_CLASS: 84,
    POSTAL_CODE: 85,
    COVID_5_11_CONFIRM_READ_DOCUMENT: 86,
    COVID_5_11_CONFIRM_I_AM_PARENT: 87,
    COVID_5_11_CONFIRM_CONSENT_TO_VACCINE: 88,
    SCREENING_FEES_ACKNOWLEDGED: 89,
    COVID_SCREENING_EMAIL_CONSENT: 90,
    COVID_SCREENING_SECURITY_CONSENT: 91,
    PHX_COVID_SCREENING_REASON: 92,
    PHX_COVID_EXPERIENCING_SYMPTOMS: 93,
    PHX_COVID_TRAVELLED_AND_ADVISED_TO_QUARANTINE: 94,
    PHX_COVID_RECEIVED_POSITIVE_PCR_TEST: 96,
    PHX_COVID_RECEIVED_POSITIVE_EXPOSURE_NOTIFICATION: 97,
    PHX_COVID_ASKED_TO_GET_A_SCREENING_TEST: 98,
    PHX_COVID_SCREENING_DETAILS_CONSENT: 99,
    PHX_COVID_SCREENING_CONSENT: 100,
    PHX_COVID_ACCEPT_RISK: 101,
    SPECIFIC_SERVICE: 102,
    OTHER_SERVICE: 103,
    NAM_EXPIRATION_DATE: 104,
    NAM_SEQUENTIAL_NUMBER: 105,
    REGION: 111,
    ...MetadataEnumCovidScreening,
    ...MetadataEnumSampling,
    PHONE_EXTENSION: 143,
    ...MetadataEnumAs624,
    PQDCS_ELIGIBILITY_DATE: 147,
    PQDCS_PRESCRIPTION_DATE: 148,
    LEGAL_FIRST_MIDDLE_LAST_NAME: 149,
    OFFER_LETTER_SENT_DATE: 150,
    PLANNED_START_DATE: 151,
    WORKED_FOR_NSHA: 152,
    NAME_USED_PREVIOUSLY: 153,
    COADMIN_INJECTION: 154,
};

export const SubModulesEnum = {
    DEFAULT: null,
    VACCINE: 1,
    PREGNANCY: 2,
    VIRTUAL: 3,
    VIRTUAL_REACTS: 4,
    PREGNANCY_DELAY: 5,
    TRAVEL: 6,
    DRUG_INJECTION: 7,
    EMPLOYER: 8,
};

export const AppModulesEnum = {
    ESTABLISHMENT: 1,
    PLACE: 2,
    RESOURCE: 3,
    SERVICE: 4,
};

export const MetadataRequiredOverridable = {
    NO_OVERRIDE: 0,
    OVERRIDABLE_PUBLIC: 1,
    OVERRIDABLE_ADMIN: 2,
    OVERRIDABLE_PUBLIC_ADMIN: 3,
};

export const UnifiedService = {
    FLU: 65,
};

export const ServiceTemplateUnderFluUnifiedService = [ServiceTemplateEnum.PRISE_DE_SANG, ServiceTemplateEnum.VACCINATION_GRIPPE];

export const CovidModules = [17, 18, 19, 20, 21, 22, 23];

export const ServiceVisibility = {
    CAN_BOOKED_PUBLIC_AND_ADMIN: 0,
    CAN_BOOKED_ADMIN_ONLY_BUT_SHOW_PUBLIC: 1,
    CAN_BOOKED_ADMIN_ONLY_AND_HIDE_PUBLIC: 2,
};

export const ProfileIdentityState = {
    VALIDATED: 'validated',
    UNVALIDATED: 'unvalidated',
};

export const CoAdministrationServiceTemplateIds = {
    FLU: ServiceTemplateEnum.VACCINATION_GRIPPE,
    COVID: ServiceTemplateEnum.VACCINATION_COVID_19,
};

export const DynamicFilterMetadataAssociation = [
    MetadataEnum.FIRST_NAME,
    MetadataEnum.LAST_NAME,
    MetadataEnum.BIRTHDAY,
];

export const GenericVaccineServiceTemplateIds = {
    SHINGLES_VACCINE: ServiceTemplateEnum.SHINGLES_VACCINE,
};

export const CovidScreeningDateFormats = {
    CREATED_OR_RESULT_TRANSMITED: 'yyyy-MM-dd HH \'h\' mm',
    SAMPLING_DATE: 'yyyy-MM-dd HH:mm',
    SHORT_DATE: 'yyyy-MM-dd',
    COMMENTS: 'yyyy MMM dd HH:mm',
};

export const ReferenceDateEnum = {
    APPT_START: 'appt_start',
    APPT_STOP: 'appt_stop',
    APPT_STATE_LAST_MODIFIED: 'appt_state_last_modified',
    APPT_CLIENT_STATE_LAST_MODIFIED: 'appt_client_state_last_modified',
    APPT_CLIENT_BIRTHDAY: 'client_birthday',
};

export const AvailableForms = {
    AH650: 1,
    MEMORY_AID: 2,
    PHX_SCREENING: 3,
    AS624: 4,
    DATA_COLLECTION: 5,
};

export const FormStatusCustom = {
    NEW: 'new',
    IN_PROGRESS: 'in_progress',
    COMPLETE: 'completed',
};

export const FormRoleId = {
    PUBLIC: 1,
};
